import {
  getAddress,
  getAffiliation,
  getBusiness,
  getCandidate,
  getConcept,
  getConsent,
  getDiscipline,
  getEducation,
  getExperience,
  getExpertiseOrExperience,
  getIncompatibility,
  getKnowledge,
  getKnowledgeAndAbility,
  getOccupation,
  getPersonalRecord,
  getPolitical,
  getProperty,
  getUploadFile,
  getUserProfile,
} from "./get";
import {
  postAddress,
  postAffiliation,
  postBusiness,
  postCandidate,
  postConcept,
  postConsent,
  postDiscipline,
  postEducation,
  postExperience,
  postExpertiseOrExperience,
  postIncompatibility,
  postKnowledge,
  postKnowledgeAndAbility,
  postOccupation,
  postPersonalRecord,
  postPolitical,
  postProperty,
  postUploadFile,
  postUserProfile,
} from "./post";

const fetchConsent = {
  get: getConsent,
  post: postConsent,
};

const fetchPersonalRecord = {
  get: getPersonalRecord,
  post: postPersonalRecord,
};

const fetchAddress = {
  get: getAddress,
  post: postAddress,
};

const fetchEducation = {
  get: getEducation,
  post: postEducation,
};

const fetchExperience = {
  get: getExperience,
  post: postExperience,
};

const fetchProperty = {
  get: getProperty,
  post: postProperty,
};

const fetchOccupation = {
  get: getOccupation,
  post: postOccupation,
};

const fetchBusiness = {
  get: getBusiness,
  post: postBusiness,
};

const fetchIncompatibility = {
  get: getIncompatibility,
  post: postIncompatibility,
};

const fetchPolitical = {
  get: getPolitical,
  post: postPolitical,
};

const fetchDiscipline = {
  get: getDiscipline,
  post: postDiscipline,
};

const fetchKnowledge = {
  get: getKnowledge,
  post: postKnowledge,
};

const fetchConcept = {
  get: getConcept,
  post: postConcept,
};

const fetchAffiliation = {
  get: getAffiliation,
  post: postAffiliation,
};

const fetchUploadFile = {
  get: getUploadFile,
  post: postUploadFile,
};

const fetchKnowledgeAndAbility = {
  get: getKnowledgeAndAbility,
  post: postKnowledgeAndAbility,
};

const fetchExpertiseOrExperience = {
  get: getExpertiseOrExperience,
  post: postExpertiseOrExperience,
};

const fetchCandidate = {
  get: getCandidate,
  post: postCandidate,
};

const fetchUserProfile = {
  get: getUserProfile,
  post: postUserProfile,
};

export {
  fetchAddress,
  fetchAffiliation,
  fetchBusiness,
  fetchCandidate,
  fetchConcept,
  fetchConsent,
  fetchDiscipline,
  fetchEducation,
  fetchExperience,
  fetchExpertiseOrExperience,
  fetchIncompatibility,
  fetchKnowledge,
  fetchKnowledgeAndAbility,
  fetchOccupation,
  fetchPersonalRecord,
  fetchPolitical,
  fetchProperty,
  fetchUploadFile,
  fetchUserProfile,
};
